import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { ResponsiveHeroImage } from "@quintype/components";
import { removeHtmlTags, replaceWithAlternates } from "../../../utils";
import "./image-thumbnail.m.css";

export const ImageThumbnail = ({ story }) => {
  const fallbackImageUrl = "https://images.assettype.com/gulfnews-uat/2024-10-15/r2sl2lqd/Gulf-News-Fallback-Image.jpg";
  const imageUrl =
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) ||
    get(story, ["hero-image-s3-key"]);
  const alternateStory = replaceWithAlternates(story);
  const imageCaption = get(story, ["hero-image-caption"], "");
  const imageAltText = imageCaption ? removeHtmlTags(imageCaption) : get(story, ["headline"], "");

  return imageUrl ? (
    <ResponsiveHeroImage
      story={alternateStory}
      aspectRatio={[4, 3]}
      defaultWidth={320}
      widths={[250, 320]}
      imgParams={{ auto: ["format", "compress"], fit: "max" }}
      alt={imageAltText}
    />
  ) : (
    <img styleName="fallback-image" className="qt-image" src={`${fallbackImageUrl}`} alt="image-fallback"></img>
  );
};
ImageThumbnail.propTypes = {
  story: PropTypes.object.isRequired,
};
